import axios from 'axios'

import csrfTokenHandler from './csrfTokenHandler'
import { API_URL } from '../utils/constants'
import convertKeysToSnakeCase from '../utils/convertKeysToSnakeCase'

// @ts-ignore
const postVenueRequest = async (data, isFirstRequest = false) => {
  await csrfTokenHandler(isFirstRequest || true)

  return axios.post(`${API_URL}/api/requests`, convertKeysToSnakeCase(data))
}
export default postVenueRequest
